// Para adicionar um novo plano: inclua uma entrada com { price, installments }
const PLAN_DISPLAY_OVERRIDES = {
  'TRILHA_IA_EXT_05_2026':     { price: '4.764,00', installments: 12 },
  'TRILHA_IA_EXT_05_2026_24':  { price: '4.764,00', installments: 24 },
  'TRILHA_FIN_EXT_05_2026_24': { price: '4.764,00', installments: 24 },
};

export default PLAN_DISPLAY_OVERRIDES;
